import types from 'constants/SalaryConstants';
import axios from 'axios';
import qs from 'qs';
import {getURL} from '../routes';

export function fetchSalaryReceiptData(uid, year, month) {
  return axios.get(getURL('/api/salary/report/') + uid + '?' + qs.stringify({
    'year': year,
    'month': month,
    'action': 'receipt'
  }))
}

export function fetchSalaryPayrollData(uid, year, month) {
  return axios.get(getURL('/api/salary/report/') + uid + '?' + qs.stringify({
    'year': year,
    'month': month,
    'action': 'payroll'
  }))
}

export function confirmSalary(uid, year, month) {
  return axios.post(getURL('/api/salary/') + uid,
                qs.stringify({
                  'year': year,
                  'month': month,
                  'action': 'confirm'
                }))
} 

export function fetchAdjustmentTypeListAPI() {
  return axios.get(getURL('/api/adjustment/type'))
}

export function addAdjustmentTypeAPI(name) {
  return axios.post(getURL('/api/adjustment/type'),
                qs.stringify({'name': name}))
}

export function updateAdjustmentTypeNameAPI(id, name) {
  return axios.put(getURL('/api/adjustment/type/') + id,
                qs.stringify({'name': name}))
}

export function deleteAdjustmentTypeAPI(id) {
  return axios.delete(getURL('/api/adjustment/type/') + id)
}

export function fetchAdjustmentTypeList() {
  return dispatch => {
    fetchAdjustmentTypeListAPI()
      .then((response) => {
        let {typeList} = response.data;
        dispatch(refreshAdjustmentTypeList(typeList));
      })
      .catch((error) => {

      })
  }
}

export function tryUpdateAdjustmentTypeName(id, name) {
  return dispatch => {
    updateAdjustmentTypeNameAPI(id, name)
      .then((response) => {
        dispatch(updateAdjustmentTypeName(id, name))
      })
      .catch((error) => {

      })
  }
}

export function tryAddAdjustmentType(name) {
  return dispatch => {
    addAdjustmentTypeAPI(name)
      .then((response) => {
        let {id} = response.data;
        dispatch(addAdjustmentType(id, name))
      })
      .catch(() => {
        alert("新增類別失敗")
      })
  }
}

export function tryDeleteAdjustmentType(id) {
  return dispatch => {
    deleteAdjustmentTypeAPI(id)
      .then((response) => {
        dispatch(deleteAdjustmentType(id))
      })
      .catch((error) => {
        alert("删除失敗!")
      })
  }
}

export function refreshAdjustmentTypeList(typeList) {
  return {
    type: types.REFRESH_ADJUSTMENT_TYPE_LIST,
    typeList
  }
}

export function updateAdjustmentTypeName(id, name) {
  return {
    type: types.UPDATE_ADJUSTMENT_TYPE_NAME,
    id, name
  }
}

export function deleteAdjustmentType(id) {
  return {
    type: types.DELETE_ADJUSTMENT_TYPE,
    id
  }
}

export function addAdjustmentType(id, name) {
  return {
    type: types.ADD_ADJUSTMENT_TYPE,
    id, name
  }
}



// WEBPACK FOOTER //
// ./src/actions/SalaryActions.js